<template>
    <div class="wrapper">
        <div class="section">
            <h2>Join an Expo</h2>
            <div> <!-- TODO: This should be a search of all expos (&rooms) -->
                <input
                class="text-input"
                v-model="expoId"
                placeholder="Enter the Expo ID"
                spellcheck="false"
                @input="validateJoinName"
                v-on:keyup.enter="joinExpo"
            />
                <SubmitButton
                    @click="joinExpo"
                    :isLoading="loading"
                    text="Join"
                />
            </div>
        </div>
        <div class="section">
            <h2>Want to host your own?</h2>
            <SubmitButton
                @click="$router.push('/newexpo')"
                text="Create a new Expo"
            />
        </div>
    </div>
</template>

<script>
import { firestore } from '../../db'

const expos = firestore.collection('expos')

export default {
    name: 'ExpoHome',
    data() {
        return {
            expoId: '',
            loading: false,
        }
    },
    methods: {
        joinExpo() {
            if (!this.expoId) {
                this.error('Enter an expo ID!')
                return
            }
            this.loading = true
            var expoDoc = expos.doc(this.expoId)
            expoDoc.get().then((snapshot) => {
                if (snapshot.exists) {
                    this.$router.push('/expo/' + this.expoId)
                } else {
                    this.error('We couldn\'t find an expo with that id!')
                }
            }).catch((e) => console.log(e))
              .finally(() => this.loading = false)
        },
        validateJoinName() {
            this.expoId = this.expoId.toLowerCase().replaceAll(/\s/gi, '-').replaceAll(/[^0-9a-z-]/gi, '')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../interface.scss';

.recs {
    position: relative;
    height: 400px;
    width: 400px;
    margin: auto;
}
.fix {
    height: 400px;
    width: 400px;
}
</style>